exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#relationshipEditor{font-family:fantasy;margin:10px}#relationshipEditor .header>*{margin-right:10px}#relationshipEditor .tableContainer{padding-top:10px;padding-bottom:10px}#relationshipEditor .tableContainer li{padding-top:5px;padding-bottom:5px}#relationshipEditor .tableContainer li>*{margin-right:5px}#relationshipEditor .characters{width:50%}#relationshipEditor .characters,#relationshipEditor .links{border:1px solid #000;display:inline-block;vertical-align:top;padding-top:10px;word-break:break-all}#relationshipEditor .links{width:40%}#relationshipEditor img{width:128px;height:128px}#relationshipEditor textarea{width:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./app/styles/relationshipEditorGOT.scss
// module id = 12
// module chunks = 0